import { render, staticRenderFns } from "./StudentActivityTableProjectCell.vue?vue&type=template&id=49968fa0&scoped=true&"
import script from "./StudentActivityTableProjectCell.vue?vue&type=script&lang=ts&"
export * from "./StudentActivityTableProjectCell.vue?vue&type=script&lang=ts&"
import style0 from "./StudentActivityTableProjectCell.vue?vue&type=style&index=0&id=49968fa0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49968fa0",
  null
  
)

export default component.exports